//@mui
import { Stack } from '@mui/system';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { getNewBeneficiary } from 'state/reducers/beneficiary.reducers';
//constants
import { Beneficiary, paymentsMethodsMapping } from 'constants/beneficiary.constants';
//components
import FormCreator from 'components/FormCreator';
import { invalidFields, fieldType, validationTypes, fieldsGroupType, field } from 'components/FormCreator/types';
import _ from 'lodash';
import { getCountriesObj } from 'state/reducers/global.reducers';
import { useMemo } from 'react';

export default function LocalPaymentForm(props: {
	handleChange: any;
	invalidFields: invalidFields;
	payment: string[];
	disabled?: boolean;
}) {
	const t = useAppSelector(selectTranslations);
	const beneficiary: Beneficiary = useAppSelector(getNewBeneficiary);
	const countries = useAppSelector(getCountriesObj);

	const selectedCountry = useMemo(
		() => Object.values(countries).find((item) => item.id === beneficiary.countryId),
		[beneficiary]
	);

	const regionsValues = useMemo(
		() =>
			selectedCountry?.regions?.map((region) => ({
				label: region.regionName,
				value: region.regionName,
			})),
		[selectedCountry]
	);

	const prefixFields = 'page.beneficiary.create.step.2.';
	let fields: field[] = [];
	props.payment?.forEach((field) => {
		if (_.has(paymentsMethodsMapping, field)) {
			if (field === 'beneficiary_state_or_province') {
				if (regionsValues?.length) {
					fields.push({
						type: fieldType.select,
						validation: [validationTypes.requierd],
						props: {
							required: true,
							name: paymentsMethodsMapping[field],
							label: t(`${prefixFields}payment_method.${field}.text`),
							value: _.get(beneficiary, paymentsMethodsMapping[field]) || '',
							options: _.values(regionsValues),
							disabled: props.disabled,
						},
					});
				} else {
					fields.push({
						type: fieldType.text,
						validation: [validationTypes.requierd],
						props: {
							required: true,
							//@ts-ignore
							name: paymentsMethodsMapping[field],
							label: t(`${prefixFields}payment_method.${field}.text`),
							//@ts-ignore
							value: _.get(beneficiary, paymentsMethodsMapping[field]) || '',
							disabled: props.disabled,
						},
					});
				}
			} else {
				fields.push({
					type: fieldType.text,
					validation: [validationTypes.requierd],
					props: {
						required: true,
						//@ts-ignore
						name: paymentsMethodsMapping[field],
						label: t(`${prefixFields}payment_method.${field}.text`),
						//@ts-ignore
						value: _.get(beneficiary, paymentsMethodsMapping[field]) || '',
						disabled: props.disabled,
					},
				});
			}
		}
	});
	return (
		<Stack spacing={2}>
			<FormCreator
				initialValidation={props.invalidFields}
				name="localPayment"
				handleChange={props.handleChange}
				fieldsGroups={[
					{
						type: fieldsGroupType.col,
						fields: fields,
					},
				]}
			/>
		</Stack>
	);
}
